<template>
    <div class="pagination">
        <b-button-group>
            <b-button
                :disabled="currentPage === 1"
                @click="goToPrev"
            >
                <
            </b-button>
            <b-button
                disabled
                variant="link"
            >
                <span class="px-1">{{ currentPage }} / {{ maxPage }}</span>
            </b-button>
            <b-button
                :disabled="currentPage === maxPage"
                @click="goToNext"
            >
                >
            </b-button>
        </b-button-group>
    </div>
</template>

<script>
import { BButtonGroup, BButton } from 'bootstrap-vue'
export default {
    name: 'Pagination',
    components: {
        BButtonGroup, BButton
    },
    data() {
        return {
            isInitiated: false,
            onPage: this.currentPage,
        }
    },
    props: {
        currentPage: {
            type: Number,
            required: true
        },
        maxPage: {
            type: Number,
            required: true
        }
    },
    methods: {
        goToNext(){
            if(this.onPage !== this.maxPage){
                this.onPage++
                this.updatePageContent()
            }
        },
        goToPrev(){
            if(this.onPage !== 1){
                this.onPage--
                this.updatePageContent()
            }
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        },
        updatePageContent() {
            this.scrollToTop()
            this.$router.push({ query: Object.assign({}, this.$route.query, { page : this.onPage }) })

            this.$emit('change-page', this.onPage)
        }
    },
    watch: {
        currentPage: function (newVal) {
            this.onPage = newVal;

            if(this.onPage > this.maxPage){
                this.onPage = this.maxPage;
                this.$emit('change-page', this.onPage);
            }

            if(this.isInitiated){
                this.$router.push({ query: Object.assign({}, this.$route.query, { page : this.onPage }) })
            }
            this.isInitiated = true
        }
    },
}
</script>
